export enum TrainType {
	REGULAR = "regular",
	LUNA = "luna",
	DANI = "dani",
}
